export const sizes = ['sm', 'md', 'lg'];
export const sizesX = ['xs', 'sm', 'md', 'lg', 'xl'];
export const sizesXS = ['xs', 'sm', 'md', 'lg'];

export type Size = typeof sizes[number];
export type SizeX = typeof sizesX[number];
export type SizeXs = typeof sizesXS[number];